module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABA0lEQVRYR+1XzQrCMAxOh+CDqEcPhe7Qkz6Fr6O+jk8xTz1s0INH9UEEWaVYRWFblv1ABwnssOWnyZePZhEQmYi2+ZjcbgHAP14yncqsyZdq/4lFSegAAPvgeNSp9O+1YnJLsp9GQkVxWTyh3DlXzitK9+3ahO9n3zak3ai9EMljBslJqfW9EiFT2Cs4WLbl1SB2Am5ayVV1Qrl1gxxCDKJT+eXyH6kNJ/SGkhHCKMUI9UGocRxggbvqf8dQ61nW9TCqX9wJhQlNLaq3fW3L+KYO2PI9hJGMEWKEMAQwPXOIEcIQwPQT4lBsiyKySmPIk/XoKk2OOIJD3H+MIxRMDhkdQi/Rvpwl6ctlwwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/course/ico2.png
// module id = uTi2
// module chunks = 1